var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":_vm.toggleWatch}},[_c('MIcon',{attrs:{"name":_vm.isWatching ? 'user-slash' : 'star'}}),_c('span',{staticClass:"ml-1 action-menu-text"},[_vm._v(" "+_vm._s(_vm.$t(_vm.isWatching ? 'unwatch' : 'watch'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }